import { render, staticRenderFns } from "./ValidatedFileFormatSelector.vue?vue&type=template&id=28776ebc"
import script from "./ValidatedFileFormatSelector.vue?vue&type=script&lang=js"
export * from "./ValidatedFileFormatSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports